import React from 'react';
import { ApolloProvider } from 'react-apollo';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'antd/dist/antd.min.css';
import './css/global.css';
import ApolloClient from './utils/apolloClient';
import App from './App';

const Root = () => (
  <Router>
    <ApolloProvider client={ApolloClient}>
      <Route component={App} />
    </ApolloProvider>
  </Router>
);

export default hot(module)(Root);



// WEBPACK FOOTER //
// ./src/Root.js